// adminpanel/Sidebar.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/logonew.png';
import {
  FaTachometerAlt,
  FaBox,
  FaShoppingCart,
  FaUsers,
  FaChartBar,
  FaCog,
  FaIndustry,
  FaWarehouse,
  FaChevronDown,
  FaChevronRight
} from 'react-icons/fa';

const Sidebar = ({ isCollapsed }) => {
  const [ordersOpen, setOrdersOpen] = useState(false);

  const mainMenuItems = [
    { path: '/admin-panel/dashboard', icon: FaTachometerAlt, label: 'Dashboard' },
    { path: '/admin-panel/products', icon: FaBox, label: 'Products' },
    { path: '/admin-panel/customers', icon: FaUsers, label: 'Customers' },
  ];

  const ordersSubItems = [
    { path: '/admin-panel/orders/all', icon: FaShoppingCart, label: 'All Orders' },
    { path: '/admin-panel/orders/today', icon: FaChartBar, label: 'Today Orders' },
    { path: '/admin-panel/orders/weekly', icon: FaChartBar, label: 'Weekly Orders' },
    { path: '/admin-panel/orders/monthly', icon: FaChartBar, label: 'Monthly Orders' },
  ];

  const toggleOrders = () => {
    setOrdersOpen(!ordersOpen);
  };

  return (
    <aside className="sticky top-0  bg-gradient-to-b from-blue-900 to-blue-950 text-white">
      {/* Logo */}
      <div className={`p-6 border-b border-blue-800 ${isCollapsed ? 'text-center' : ''}`}>
        <div className={`flex ${isCollapsed ? 'flex-col items-center' : 'items-center space-x-3'}`}>
          
          {!isCollapsed && (
            <div className="flex items-center space-x-2">
              <img src={Logo} alt="Logo" className="w-8 h-8 rounded" />
              <h2 className="text-xl font-bold">Sridanth</h2>
            </div>
          )}
          
          {isCollapsed && (
            <div className="flex flex-col items-center">
              <img src={Logo} alt="Logo" className="w-8 h-8 rounded mb-2" />
              <span className="text-xs font-bold">SD</span>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="p-4 space-y-1">
        {mainMenuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center ${isCollapsed ? 'justify-center' : 'space-x-3'} px-4 py-3 rounded-lg transition-all duration-200 ${
                isActive
                  ? 'bg-blue-700 text-white shadow-lg shadow-blue-700/50'
                  : 'hover:bg-blue-800/50 text-blue-100 hover:text-white'
              }`
            }
            title={isCollapsed ? item.label : ''}
          >
            <item.icon className="text-lg" />
            {!isCollapsed && <span className="font-medium">{item.label}</span>}
          </NavLink>
        ))}

        {/* Orders Dropdown */}
        <div className={`${isCollapsed ? 'text-center' : ''}`}>
          <button
            onClick={toggleOrders}
            className={`flex items-center w-full ${isCollapsed ? 'justify-center' : 'justify-between'} px-4 py-3 rounded-lg transition-all duration-200 hover:bg-blue-800/50 text-blue-100 hover:text-white`}
            title={isCollapsed ? 'Orders' : ''}
          >
            <div className="flex items-center space-x-3">
              <FaShoppingCart className="text-lg" />
              {!isCollapsed && <span className="font-medium">Orders</span>}
            </div>
            {!isCollapsed && (
              ordersOpen ? <FaChevronDown className="text-sm" /> : <FaChevronRight className="text-sm" />
            )}
          </button>

          {/* Orders Submenu */}
          {!isCollapsed && ordersOpen && (
            <div className="ml-8 mt-1 space-y-1 border-l border-blue-700 pl-4">
              {ordersSubItems.map((subItem) => (
                <NavLink
                  key={subItem.path}
                  to={subItem.path}
                  className={({ isActive }) =>
                    `flex items-center space-x-2 px-3 py-2 rounded transition-all duration-200 ${
                      isActive
                        ? 'bg-blue-700 text-white'
                        : 'hover:bg-blue-800/30 text-blue-200'
                    }`
                  }
                >
                  <subItem.icon className="text-sm" />
                  <span className="text-sm font-medium">{subItem.label}</span>
                </NavLink>
              ))}
            </div>
          )}

          {/* Collapsed view for orders */}
          {isCollapsed && ordersOpen && (
            <div className="mt-1 space-y-1">
              {ordersSubItems.map((subItem) => (
                <NavLink
                  key={subItem.path}
                  to={subItem.path}
                  className="flex items-center justify-center px-2 py-2 rounded transition-all duration-200 hover:bg-blue-800/30"
                  title={subItem.label}
                >
                  <subItem.icon className="text-sm" />
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {/* Additional Menu Items (Commented out) */}
        {/* 
        {!isCollapsed && (
          <div className="pt-4 border-t border-blue-800">
            <h4 className="px-4 py-2 text-xs uppercase tracking-wider text-blue-300 font-semibold">
              Operations
            </h4>
            {[
              { path: '/admin-panel/production', icon: FaIndustry, label: 'Production' },
              { path: '/admin-panel/inventory', icon: FaWarehouse, label: 'Inventory' },
              { path: '/admin-panel/reports', icon: FaChartBar, label: 'Reports' },
              { path: '/admin-panel/settings', icon: FaCog, label: 'Settings' },
            ].map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive
                      ? 'bg-blue-700 text-white'
                      : 'hover:bg-blue-800/50 text-blue-100 hover:text-white'
                  }`
                }
              >
                <item.icon className="text-lg" />
                <span className="font-medium">{item.label}</span>
              </NavLink>
            ))}
          </div>
        )}
        */}
      </nav>

      {/* Stats Panel - Only show when expanded */}
      {/* {!isCollapsed && (
        <div className="mt-8 p-4 border-t border-blue-800">
          <div className="bg-blue-800/30 rounded-lg p-4 backdrop-blur-sm">
            <h4 className="font-medium mb-3 text-blue-100">Quick Stats</h4>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-blue-200">Active Orders</span>
                <span className="font-semibold text-white bg-blue-700 px-2 py-1 rounded text-sm">28</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-blue-200">Today's Orders</span>
                <span className="font-semibold text-green-300">12</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-blue-200">This Week</span>
                <span className="font-semibold text-white">45</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-blue-200">This Month</span>
                <span className="font-semibold text-white">156</span>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </aside>
  );
};

export default Sidebar;